import styled from 'styled-components';

const DragContainer = styled.span`
    margin-left: auto;
    margin-right: 10px;
    font-size: 1.4em;
    cursor: move;
`;

const HeaderContainer = styled.div`
    display: flex;
    background-color: #ffffff;
    border-bottom: 1px solid #e0e0e0;
`;

const Header = styled.div`
    text-transform: uppercase;
    text-align: center;
    color: #143e44;
    font-family: 'Atlas Grotesk Medium', sans-serif;
    font-size: 12px;
    font-weight: 500;
    line-height: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

const ScrollableBody = styled.div`
    height: 83%;
    overflow: auto;
    padding: 0 16px;
    background-color: #ffffff;
    margin-top: 5px;
    margin-bottom: 5px;
`;

const ScrollableBodyTall = styled.div`
    height: 90%;
    overflow: auto;
    padding: 0 16px 0 16px;
    background-color: #ffffff;
    margin-top: 5px;
`;

export { DragContainer, HeaderContainer, Header, ScrollableBody, ScrollableBodyTall };
